// test1162
(1162 && 0);
